import { createFileRoute } from '@tanstack/react-router';
import { RemindersPage } from '@/features/foodcost/SollecitiPage';

export const Route = createFileRoute('/_app/foodcost/solleciti')({ component: RemindersPage });
